import { useState } from 'react';

function useLocalStorage<T>(key: string, defaultValue: T): [T, (v: T) => void] {
	const [value, setValue] = useState<T>(() => {
		try {
			const stored = localStorage.getItem(key);

			return stored != null ? JSON.parse(stored) : defaultValue;
		} catch {
			return defaultValue;
		}
	});

	const set = (v: T) => {
		localStorage.setItem(key, JSON.stringify(v));
		setValue(v);
	};

	return [value, set];
}

export default useLocalStorage;
